import {
  AppStatusEnum,
  PTBlastEmailMessageTypeEnum,
  ProgramCodes,
  ProgramTitles,
  RequestStatus,
} from 'common/enum';

const AppListDefault: AppProgram[] = [
  {
    code: ProgramCodes.FILE_LIBRARY,
    title: ProgramTitles.FILE_LIBRARY,
    visible: true,
    active: false,
    hasPermission: true,
    status: AppStatusEnum.GRANT,
  },
  {
    code: ProgramCodes.RESOURCE_REQUEST,
    title: ProgramTitles.RESOURCE_REQUEST,
    visible: true,
    active: false,
    hasPermission: true,
    status: AppStatusEnum.GRANT,
  },
  {
    code: ProgramCodes.PATIENT_TRANSFER,
    title: ProgramTitles.PATIENT_TRANSFER,
    visible: true,
    active: false,
    hasPermission: true,
    status: AppStatusEnum.GRANT,
  },
  {
    code: ProgramCodes.MOD,
    title: ProgramTitles.MOD,
    visible: true,
    active: false,
    hasPermission: true,
    status: AppStatusEnum.GRANT,
  },
  {
    code: ProgramCodes.FAQ,
    title: ProgramTitles.FAQ,
    visible: true,
    active: false,
    hasPermission: true,
    status: AppStatusEnum.GRANT,
  },
];

const UOMOptions: OptionSelect[] = [
  { label: 'Battalion', value: 'battalion' },
  { label: 'Bottle', value: 'bottle' },
  { label: 'Box', value: 'box' },
  { label: 'Case', value: 'case' },
  { label: 'Company', value: 'company' },
  { label: 'Dozen', value: 'dozen' },
  { label: 'Each', value: 'each' },
  { label: 'Gallon', value: 'gallon' },
  { label: 'Half Truckload', value: 'half-truckload' },
  { label: 'Individual', value: 'individual' },
  { label: 'Liter', value: 'liter' },
  { label: 'Pallet', value: 'pallet' },
  { label: 'Platoon', value: 'platoon' },
  { label: 'Pound', value: 'pound' },
  { label: 'Squad', value: 'squad' },
  { label: 'Strike Team', value: 'strike-team' },
  { label: 'Task Force', value: 'task-force' },
  { label: 'Team', value: 'team' },
  { label: 'Ton', value: 'ton' },
  { label: 'Truckload', value: 'truckload' },
];

const BedTypeOptions: OptionSelect[] = [
  { label: 'ICU', value: 'ICU' },
  { label: 'LTAC', value: 'LTAC' },
  { label: 'Med-Surg', value: 'Med-Surg' },
  { label: 'Med-Tele', value: 'Med-Tele' },
  { label: 'NICU', value: 'NICU' },
  { label: 'PCU', value: 'PCU' },
  { label: 'Peds', value: 'Peds' },
];

const EMSOptions: OptionSelect[] = [
  { label: 'ALS', value: 'ALS' },
  { label: 'BLS', value: 'BLS' },
  { label: 'CCT', value: 'CCT' },
  { label: 'Hospital Arranged', value: 'hospital-arranged' },
];

const ResReqStatusOptions: OptionSelect[] = Object.entries(RequestStatus).map((req) => ({
  label: req[1],
  value: req[1],
}));

const PalmettoResourceRequestStaticInfo = {
  pvIncidentID: 2893,
  pvIncidentName: '2025 Healthcare Resource Requests',
  pvUserID: 13577,
  pvPositionID: 779,
};

const BlastEmailMessageTypeOptions: OptionSelect[] = [
  { label: 'Message', value: 'message' },
  { label: 'Contacts', value: 'contacts' },
];

const PTBlastEmailMessageTypeOptions: OptionSelect[] = [
  { label: 'Hurricane Evacuation', value: 'hurricane' },
  { label: 'Local/Regional Event', value: 'local_regional' },
];

const PTBlastEmailTemplates: Record<
  (typeof PTBlastEmailMessageTypeEnum)[keyof typeof PTBlastEmailMessageTypeEnum],
  { subject: string; body: string }
> = {
  hurricane: {
    subject: 'Palmetto Healthcare Portal patient request',
    body: 'In preparation for the impending hurricane, the Governor has issued a mandatory medical evacuation. This has triggered activation of the Palmetto Healthcare Portal for any patient movement requests.\n\n{INCIDENT NAME}\n\nIf you are a transferring hospital who may need assistance with patient movement, use the "Patient Transfer" link below:\n\nTransferring Hospitals Click Here: Patient Transfer Link\n\nIf you are a receiving hospital who can accept patients, use the "Receiving Hospital Link" below to review and accept patients.\n\nReceiving Hospitals Click Here: Receiving Hospital Link\n\nRespectfully,\n\nThe SC Healthcare Coalition Team\n\nTHIS IS A SYSTEM GENERATED EMAIL MESSAGE, PLEASE DO NOT RESPOND TO THIS EMAIL.',
  },
  local_regional: {
    subject: 'Healthcare Portal patient request',
    body: 'A local or regional event has occurred impacting one or more hospitals. This has triggered activation of the Healthcare Portal for any patient movement requests.\n\n{INCIDENT NAME}\n\nIf you are an impacted hospital who may need assistance with patient movement, use the "Patient Transfer" link below.\n\nTransferring Hospital(s) Click Here: Patient Transfer Link\n\nIf you are a receiving hospital who can accept patients, use the "Receiving Hospital Link" below to review and accept patients:\n\nReceiving Hospital(s) Click Here: Receiving Hospital Link\n\nRespectfully,\n\nThe SC Healthcare Coalition Team\n\nTHIS IS A SYSTEM GENERATED EMAIL MESSAGE, PLEASE DO NOT RESPOND TO THIS EMAIL.',
  },
};

export {
  AppListDefault,
  BedTypeOptions,
  BlastEmailMessageTypeOptions,
  EMSOptions,
  PalmettoResourceRequestStaticInfo,
  PTBlastEmailMessageTypeOptions,
  PTBlastEmailTemplates,
  ResReqStatusOptions,
  UOMOptions,
};
